import {createSelector} from "@reduxjs/toolkit";
import {OtsUIState} from "../../ots-ui-store";

const selectId = (_state: OtsUIState, id: string) => id
const selectSiteUI = (state: OtsUIState) => state.uiSite

export const selectSiteUIFilter = createSelector([selectSiteUI, selectId], (ui, id) => ui[id]?.filter)
